import {
  layerStack
} from "./chunk-G4GHYT27.mjs";

// src/pointer-event-outside.ts
import { getDocument } from "@zag-js/dom-query";
var originalBodyPointerEvents;
function assignPointerEventToLayers() {
  layerStack.layers.forEach(({ node }) => {
    node.style.pointerEvents = layerStack.isBelowPointerBlockingLayer(node) ? "none" : "auto";
  });
}
function clearPointerEvent(node) {
  node.style.pointerEvents = "";
}
var DATA_ATTR = "data-inert";
function disablePointerEventsOutside(node) {
  const doc = getDocument(node);
  if (layerStack.hasPointerBlockingLayer() && !doc.body.hasAttribute(DATA_ATTR)) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    doc.body.style.pointerEvents = "none";
    doc.body.setAttribute(DATA_ATTR, "");
  }
  return () => {
    if (layerStack.hasPointerBlockingLayer())
      return;
    doc.body.style.pointerEvents = originalBodyPointerEvents;
    doc.body.removeAttribute(DATA_ATTR);
    if (doc.body.style.length === 0)
      doc.body.removeAttribute("style");
  };
}

export {
  assignPointerEventToLayers,
  clearPointerEvent,
  disablePointerEventsOutside
};
